import { IconLoader } from '@ui/src';
import ColumnRowUsers from '../../user-list/column-row-users/column-row-users';
import ColumnHead from './column-head';
import { ColumnUsersTypes } from './types';

import cn from './column.module.css';

const ColumnUsers = ({
  users,
  isLoading,
  userId,
  emptyTitle,
  onSearch,
  search,
  popupIsOpen,
  roles,
  selectedRoles,
  onlyArchived,
}: ColumnUsersTypes): React.JSX.Element => {
  let content: React.JSX.Element;

  if (isLoading) {
    content = (
      <div className={cn.columnLoader}>
        <IconLoader />
      </div>
    );
  } else {
    content = users?.length ? (
      <div
        className={`${cn.columnContent} ${popupIsOpen ? cn.lessHeight : ''}`}
      >
        {users?.map((user) => (
          <ColumnRowUsers
            user={user}
            key={user.id}
            isSelectedRow={user.id === userId}
          />
        ))}
      </div>
    ) : (
      <div className={cn.emptyTitle}>{emptyTitle}</div>
    );
  }
  return (
    <div className={cn.column}>
      <ColumnHead
        title="Users"
        onSearch={onSearch}
        placeholder="Find users..."
        value={search}
        roles={roles}
        selectedRoles={selectedRoles}
        onlyArchived={onlyArchived}
        userColumn
      />
      {content}
    </div>
  );
};

export default ColumnUsers;
